import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {
  onGetPagedAllAddresses,
  onCreateAddress,
  onDeleteAddress,
  onGetAddress,
  onUpdateAddress,
  onGetAddressesByUserId,
  onGetPagedAllUserAddresses,
  onUpdateUserAddressforUser,
  onCreateUserAddressforUser,
  onDeleteUserAddressforUser,
} from '../../../app/modules/user-definitions/components/addresses/core/_requests'
import {
  onGetAddressTypes,
  onGetCountries,
  onGetDistrictsByProvinceId,
  onGetProvincesByCountryId,
  onGetUsers,
} from '../../../app/services/dataForComboBox/dataForComboBoxService'
import { onGetAddressesAllOfTheUser } from '../../../app/modules/profile/addresses/core/_requests'
interface AddressState {
  addresses: any
  userAddresses: any
  address: any
  users: any
  addressTypes: any
  countries: any
  provinces: any
  districts: any
  isLoading: boolean
}
const initialState = {
  addresses: [],
  userAddresses: [],
  address: null,
  users: [],
  addressTypes: [],
  countries: [],
  provinces: [],
  districts: [],
  isLoading: true,
} as AddressState

export const fetchUsers = createAsyncThunk('address/fetchUsers', async () => {
  const data: any = await onGetUsers()

  return data.data.result.items
})

export const fetchAddressTypes = createAsyncThunk('address/fetchAddressTypes', async () => {
  const data: any = await onGetAddressTypes()

  return data.data.result.items
})

export const fetchCountries = createAsyncThunk('address/fetchCountries', async () => {
  const data: any = await onGetCountries()
  return data.data.result
})

export const fetchProvinces = createAsyncThunk('address/fetchProvinces', async (param: any) => {
  const data: any = await onGetProvincesByCountryId(param)
  return data.data.result
})

export const fetchDistricts = createAsyncThunk('address/fetchDistricts', async (param: any) => {
  const data: any = await onGetDistrictsByProvinceId(param)
  return data.data.result
})

export const fetchAddresses = createAsyncThunk('address/fetchAddresses', async (param: any) => {
  const data: any = await onGetPagedAllAddresses(param)
  return data.data.result
})

export const fetchAddressesByUserId = createAsyncThunk(
  'address/fetchAddressesByUserId',
  async (param: any) => {
    const data: any = await onGetAddressesByUserId(param)
    return data.data.result
  }
)

export const fetchAddress = createAsyncThunk('address/fetchAddress', async (param: any) => {
  const data: any = await onGetAddress(param)
  return data.data.result
})

export const updateAddress = createAsyncThunk('address/updateAddress', async (param: any) => {
  const data: any = await onUpdateAddress(param)
  return data.data
})

export const createAddress = createAsyncThunk('address/createAddress', async (param: any) => {
  const data: any = await onCreateAddress(param)
  return data.data
})

export const deleteAddress = createAsyncThunk('address/deleteAddress', async (param: any) => {
  const data: any = await onDeleteAddress(param)
  return data.data
})

export const updateUserAddress = createAsyncThunk('address/updateUserAddress', async (param: any) => {
  const data: any = await onUpdateUserAddressforUser(param)
  return data.data
})

export const createUserAddress = createAsyncThunk('address/createUserAddress', async (param: any) => {
  const data: any = await onCreateUserAddressforUser(param)
  return data.data
})

export const deleteUserAddress = createAsyncThunk('address/deleteUserAddress', async (param: any) => {
  const data: any = await onDeleteUserAddressforUser(param)
  return data.data
})

export const fetchUserAddresses = createAsyncThunk('address/fetchUserAddresses', async () => {
  const data: any = await onGetAddressesAllOfTheUser()
  return data.data.result
})

const addressSlice = createSlice({
  name: 'address',
  initialState,
  reducers: {
    clearAddresses: (state) => {
      state.addresses = []
    },
    clearUserAddresses: (state) => {
      state.userAddresses = []
    },
    clearAddress: (state) => {
      state.address = null
    },
    activateLoading: (state) => {
      state.isLoading = true
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchAddresses.pending, (state: any) => {
      state.isLoading = true
    })
    builder.addCase(fetchAddresses.fulfilled, (state: any, action) => {
      state.addresses = action.payload
      state.isLoading = false
    })
    builder.addCase(fetchAddresses.rejected, (state: any) => {
      state.isLoading = false
    })
    builder.addCase(fetchAddressesByUserId.pending, (state: any) => {
      state.isLoading = true
    })
    builder.addCase(fetchAddressesByUserId.fulfilled, (state: any, action) => {
      state.addresses = action.payload
      state.isLoading = false
    })
    builder.addCase(fetchAddressesByUserId.rejected, (state: any) => {
      state.isLoading = false
    })
    builder.addCase(fetchAddress.fulfilled, (state: any, action) => {
      state.address = action.payload
    })
    builder.addCase(fetchUsers.fulfilled, (state: any, action) => {
      state.users = action.payload
    })
    builder.addCase(fetchAddressTypes.fulfilled, (state: any, action) => {
      state.addressTypes = action.payload
    })
    builder.addCase(fetchCountries.fulfilled, (state: any, action) => {
      state.countries = action.payload.items
    })
    builder.addCase(fetchProvinces.fulfilled, (state: any, action) => {
      state.provinces = action.payload.items
    })
    builder.addCase(fetchDistricts.fulfilled, (state: any, action) => {
      state.districts = action.payload.items
    })
    builder.addCase(fetchUserAddresses.pending, (state: any) => {
      state.isLoading = true
    })
    builder.addCase(fetchUserAddresses.fulfilled, (state: any, action) => {
      state.userAddresses = action.payload
      state.isLoading = false
    })
    builder.addCase(fetchUserAddresses.rejected, (state: any) => {
      state.isLoading = false
    })
  },
})

export const {clearAddresses, clearUserAddresses, clearAddress, activateLoading} = addressSlice.actions

export default addressSlice.reducer
